<template>
  <div>
    <a-modal modal-id="add-category">
      <div slot="title">Add Category</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <label for="">Name</label>
            <input type="text" name="" id="" class="form-control" placeholder="Code" v-model="addCategory.Name">
          </div>
          <div class="col-lg-12 m-b-sm">
            <button class="btn btn-primary btn-sm pull-right"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal modal-id="add-option">
      <div slot="title">Add Option</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <v-select :options="categories" label="Name" index="TrackingCategoryID" v-model="addOption.category"></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <label for="">Name</label>
            <input type="text" name="" id="" class="form-control" placeholder="Name" v-model="addOption.Name">
          </div>
          <div class="col-lg-12 m-b-sm">
            <button class="btn btn-primary btn-sm pull-right" @click="saveOption"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Tracking
          <a class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-category"><i
            class="fa fa-plus" @click="addCategory = {}"></i> New Category</a>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <table class="table table-striped table-hover m-t-sm">
              <template v-for="cat in categories">
                <thead :key="'head-' + cat.TrackingCategoryID">
                <tr>
                  <th>{{ cat.Name }}</th>
                  <th>
                    <button
                      class="btn btn-xs btn-primary pull-right m-l-sm"
                      data-toggle="modal" data-target="#add-option"
                      @click="addOption.category = cat.TrackingCategoryID"><i class="fa fa-plus"></i> Add Option</button>
                    <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-category"><i class="fa fa-edit"></i> Edit</button>
                  </th>
                </tr>
                </thead>
                <tbody :key="'body-' + cat.TrackingCategoryID">
                <tr v-for="opts in cat.Options" :key="opts.TrackingOptionID">
                  <td>{{ opts.Name }}</td>
                  <td></td>
                </tr>
                </tbody>
              </template>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      filters: {},
      addCategory: {},
      addOption: {}
    }
  },
  computed: {
    ...mapGetters({
      categories: 'getXeroCategories'
    })
  },
  mounted () {
    if (!this.categories.length) {
      this.$store.dispatch('fetchXeroCategories')
    }
  },
  methods: {
    saveCategory () {},
    async saveOption () {
      await axios.put(`/integrations/xero/categories/${this.addOption.category}/options`, {
        Name: this.addOption.Name
      })
      $('#add-option').modal('hide')
      this.$toastr.success('Tracking Option added successfully')
      await this.$store.dispatch('fetchXeroCategories')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tracking.vue